module.exports = __webpack_public_path__ + "static/media/photo20.866c6d9c.jpg";